import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue'
// import type { PropType } from 'vue'
import DButton from '@/components/base/DButton.vue'
import * as cronParser from 'cron-parser'
import cronstrue from 'cronstrue'
import InfoIcon from '@/components/Icons/InfoIcon.vue'
import PenIcon from '@/components/Icons/PenIcon.vue'

type Cron = {
  minute: string
  hour: string
  dayOfMonth: string
  month: string
  dayOfWeek: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CronEditor',
  props: {
  modelValue: {
    type: String,
    // required: true
  },
  // cronValue: {
  //   type: Object,
  //   required: true
  // }
},
  emits: ['setCrontab'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

// add emit
const emits = __emit
const props = __props

const frequencies = ref(['every'])
const timeUnits = ref(['minutes', 'hours', 'days', 'weeks', 'months'])

const selectedFrequency = ref('every')
const selectedNumber = ref('5')
const selectedTimeUnit = ref('minutes')
const isValidCrontab = ref(true)
const editing = ref(false)

const crontab = ref<Cron>({
  minute: '',
  hour: '',
  dayOfMonth: '',
  month: '',
  dayOfWeek: ''
})

const crontabSentence = ref(Object.values(crontab.value).join(' '))

onMounted(() => {
  if (props.modelValue) {
    const [minute, hour, dayOfMonth, month, dayOfWeek] = props.modelValue.split(' ')
    crontab.value = {
      minute: minute,
      hour: hour,
      dayOfMonth: dayOfMonth,
      month: month,
      dayOfWeek: dayOfWeek
    }
    createReadableCronString(crontab.value)
  }
})


function computeCronValue (inputNumber, frequency, timeUnit) {
  if (frequency === 'every') {
    switch (timeUnit) {
      case 'minutes':
        crontab.value.minute = `*/${inputNumber}`
        crontab.value.hour = '*'
        crontab.value.dayOfMonth = '*'
        crontab.value.month = '*'
        crontab.value.dayOfWeek = '*'
        break
      case 'hours':
        crontab.value.minute = '0'
        crontab.value.hour = `*/${inputNumber}`
        crontab.value.dayOfMonth = '*'
        crontab.value.month = '*'
        crontab.value.dayOfWeek = '*'
        break
      case 'days':
        crontab.value.minute = '0'
        crontab.value.hour = '0'
        crontab.value.dayOfMonth = `*/${inputNumber}`
        crontab.value.month = '*'
        crontab.value.dayOfWeek = '*'
        break
      case 'weeks':
        crontab.value.minute = '0'
        crontab.value.hour = '0'
        crontab.value.dayOfMonth = '*'
        crontab.value.month = '*'
        crontab.value.dayOfWeek = `*/${inputNumber * 7}` // Sunday is 0
        break
      case 'months':
        crontab.value.minute = '0'
        crontab.value.hour = '0'
        crontab.value.dayOfMonth = '1'
        crontab.value.month = `*/${inputNumber}`
        crontab.value.dayOfWeek = '*'
        break
    }
  }

  createReadableCronString(crontab.value)
}

function createReadableCronString (cron: Cron) {
  const crontabString = Object.values(cron).join(' ')
  if (validateCronstring(crontabString)) {
    emits('setCrontab', crontabString)
  }
  crontabSentence.value = cronstrue.toString(crontabString)
}

function validateCronstring (crontab: string) {
  if (!crontab) return false
  try {
    cronParser.parseExpression(crontab)
  } catch (e) {
    return false
  }
  editing.value = false
  return true
}

// function validateCronSegment(segment: string, type: string) {
//   let range: { min: number, max: number}
//   switch (type) {
//     case 'minute':
//       range = { min: 0, max: 59 }
//       break
//     case 'hour':
//       range = { min: 0, max: 23 }
//       break
//     case 'dayOfMonth':
//       range = { min: 1, max: 31 }
//       break
//     case 'month':
//       range = { min: 1, max: 12 }
//       break
//     case 'dayOfWeek':
//       range = { min: 0, max: 6 }
//       break
//     default:
//       console.error(`Invalid crontab segment type: ${type}`)
//       return false
//   }

//   // check for special characters
//   if (segment === '*') return true
//   const values = segment.split(/[-/,]/)

//   for (const value of values) {
//     if (isNaN(Number(value)) || Number(value) < range.min || Number(value) > range.max) {
//       return false
//     }
//   }

//   // try {
//   //   cronParser.parseExpression(`* * * * * ${segment}`)
//   // } catch (err) {
//   //   return false;
//   // }

//   return true
// }


const __returned__ = { emits, props, frequencies, timeUnits, selectedFrequency, selectedNumber, selectedTimeUnit, isValidCrontab, editing, crontab, crontabSentence, computeCronValue, createReadableCronString, validateCronstring, onMounted, ref, DButton, get cronParser() { return cronParser }, get cronstrue() { return cronstrue }, InfoIcon, PenIcon }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})